<script lang="ts" setup>
  import { computed } from 'vue';
  
  import { themingCssClass } from "../../mixins/theming-mixin";
  import { recProps } from '../../mixins/rec-component';

  const props = defineProps({...recProps()});

  const asLines = computed(()=> {
    if (!props.description.ivalue) return [];
    return props.description.ivalue.split("\n");
  });
</script>

<template>
  <div class="components__rec-text-field">
    <div
      v-if="description.title"
      class="text-field-title"
      v-bind:class="[themingCssClass('normal')]"
    >
      {{ description.title }}
    </div>
    <textarea
      v-bind:rows="description.rows"
      v-bind:name="description.name"
      v-model="description.ivalue"
      v-if="!description.readonly"
    ></textarea>
    <p>
      <template v-for="(line, index) in asLines" v-bind:key="index">
        <span v-if="description.readonly">{{ line }}</span>
        <br />
      </template>
    </p>
  </div>
</template>

<style lang="scss" scoped>
.components__rec-text-field {
  textarea {
    width: 100%;
    resize: vertical;
  }

  .text-field-title {
    margin-bottom: 10px;
    margin-top: 20px;
  }
}
</style>
